import clsx from 'clsx';
import { TextLink } from 'components/UI/Link/TextLink';
import { useRouter } from 'next/router';

import styles from './TeamMiniNav.module.scss';

export const TeamMiniNav = () => {
  const { pathname } = useRouter();
  const isCollegePath = pathname.includes('college');
  const isTeamPath = pathname.includes('teams');

  return (
    <div className={styles.topnav}>
      <TextLink
        className={clsx(styles.toplink, {
          [styles.active]: isCollegePath,
        })}
        color="inherit"
        href={'/college/'}
        underline="none"
        variant="subtitle1"
      >
        Team Channels
      </TextLink>
      <TextLink
        className={clsx(styles.toplink, {
          [styles.active]: isTeamPath,
        })}
        color="inherit"
        href={'/teams/'}
        underline="none"
        variant="subtitle1"
      >
        Fan Sites
      </TextLink>
    </div>
  );
};
